import { useGLTF } from "@react-three/drei";
import * as THREE from 'three';
import { MeshPhysicalMaterial } from "three";
import React, { useMemo, useState, useEffect, useRef } from 'react'
import { a, useSpring } from '@react-spring/three'
import { useThree } from '@react-three/fiber'
import { useDrag, useMove } from 'react-use-gesture'
import { motion } from "framer-motion-3d";
//import { useEffect } from "react/cjs/react.production.min";




// 10 changed to 100
const Inspector = ({children, speed=10}) => {
  
    const { size } = useThree()
    const euler = useMemo(() => new THREE.Euler(), [])
    const [spring, set] = useSpring(() => ({
      rotation: [0, 0, 0],
    }))
    // useDrag changed to useMove
    const bind = useDrag(({ delta: [dx, dy] }) => {
      euler.y += (dx / size.width) * speed
      euler.x += (dy / size.width) * speed
      euler.x = THREE.MathUtils.clamp(euler.x, -Math.PI / 2, Math.PI / 2)
      set({ rotation: euler.toArray().slice(0, 3) })
    })
    return (
      <a.group {...bind()} {...spring}>
        {children}
      </a.group>
    )
  }



export const Product = ({...props}, ref7) => {
    const model = useGLTF(props.path);

    const [isScale, setIsScale] = useState(false);
    const [currentScale, setCurrentScale] = useState(1);
    const [hovered, setHovered] = useState(null)
    const selected = hovered ? [hovered] : undefined

    useEffect(() => {
      document.body.style.cursor = hovered ? 'pointer' : 'auto'
    }, [hovered])


    const mat7 = new MeshPhysicalMaterial({
      color: 0xfcba03
    })


    model.scene.traverse(child => {
        if (child.isMesh){
            child.castShadow = true;
            child.receiveShadow = true; 
            child.material.side = THREE.FrontSide;
        }
    })

    const onPointerOver = () => {
      setCurrentScale(1.04)
      setHovered(true)
    }

    const onPointerOut = () => {
      setCurrentScale(1)
      setHovered(false)
    }
    

    return(
            <Inspector speed={props.speed} >
                   <motion.primitive 
                   {...props} 
                   ref={ref7}
                  //  whileHover={{ scale: 1.04 }} 
                   object={model.scene} 
                   dispose={null} 
                    onPointerOver={onPointerOver}
                    onPointerOut={onPointerOut}
                    animate={{ scale: currentScale }}
                   />
            </Inspector>    
    )
}









// export const TestBox = React.forwardRef(({...props}, boxRef) => {
//   const {materials, nodes } = useGLTF(props.path);

//   const mat = new MeshPhysicalMaterial({
//     color: 0xfcba03,
//     reflectivity: 0.7,
//     roughness: 0.7,
//   })

//   return(
//     <mesh 
//       geometry={nodes.Circle001.geometry}
//       material={materials['08 - Default.002']}
//       position={[0, 0.5, 0]} 
//       rotation={[0, 0, 0]}
//       scale={[0.01 , 0.01, 0.01]}
//       ref={boxRef} 
//       onPointerOver={props.onPointerOver} 
//       onPointerOut={props.onPointerOut}
//     />
//   )
// })

